<br><button type="button" [disabled]="isButtonReadOnly" 
          (click)="exportButtonClick()">Export</button>
    <label class="warning">{{ errorMessage }}</label> 
    <p [ngClass]="{ 'loading': reportLoading }"></p>